<!-- Presentational component for displaying the price of something in the cart -->
<template>
	<div
		v-if="plan && cartItem && priceDetails"
		class="place-self-center justify-self-end"
	>
		<PriceDetailsDisplay
			:priceDetails="priceDetails"
			:credit="isCredit"
			:isPackage="isPackage"
		/>
	</div>
</template>

<script setup lang="ts">
import PriceDetailsDisplay from './PriceDetailsDisplay.vue'
import type Plan from '@/classes/Plan'
import { PbProductType } from '@/enums/PbProductType'
import { isCartSubItem } from '@/guards'
import {
	type CartItemAndLineItem,
	type CartSubItemAndLineItem,
	useMerchandise,
} from '@/mixins/merchandise'
import { computed, type PropType } from 'vue'

const props = defineProps({
	plan: Object as PropType<Plan>,
	cartItem: Object as PropType<CartItemAndLineItem | CartSubItemAndLineItem>,
	credit: Boolean,
	isPackage: Boolean,
})

const { getCartItemPrice, qualifiesForDiscount } = useMerchandise()

// Computes the price details of a cart item.
const priceDetails = computed(() => {
	if (!props.plan || !props.cartItem) return undefined

	const isPackage = props.cartItem.lineItem?.category === PbProductType.Package

	if (isPackage) {
		return {
			price: props.cartItem?.lineItem?.fixedPrice ?? 0,
			originalPrice: 0,
			quantity: 0,
			guaranteed: 0,
			nonGuaranteed: 0,
		}
	}

	return getCartItemPrice(props.plan as Plan, props.cartItem)
})

const isCredit = computed(() => {
	if (!props.cartItem || !props.cartItem.lineItem) return false

	return (
		isCartSubItem(props.cartItem) &&
		priceDetails.value &&
		priceDetails.value.price > 0 &&
		qualifiesForDiscount(props.cartItem.lineItem)
	)
})
</script>
